import { version, build } from '../../package.json'
export const VERSION = version + '.' + build

export const APP_TITLE = '芸専卒業判定 Web ' + process.env.VUE_APP_YEAR
